import { create, w } from '@dojo/framework/core/vdom';
import { Dialog } from '@dojo/widgets/dialog';
import { icache } from '@dojo/framework/core/middleware/icache';
import { isEmpty } from 'lodash-es';
import { theme } from '@dojo/framework/core/middleware/theme';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
const factory = create({
    icache,
    theme,
    nls: createNlsMiddleware('ditabook')
}).properties();
export const QuizEndModal = factory(({ properties, middleware: { icache, nls } }) => {
    const { score, placeHolder = 'Placeholder' } = properties();
    const { messages } = nls();
    const { quiz_end_timeout = '[ditabook] quiz_end_timeout', quiz_end_praise_title: praise_title_obj = '[ditabook] quiz_end_praise_title', quiz_end_praise_body: praise_body_obj = '[ditabook] quiz_end_praise_body' } = messages;
    const praise_title = praise_title_obj ? JSON.parse(praise_title_obj.replace(/[\r\n\s]+/gm, ' ')) : {};
    const praise_body = praise_body_obj ? JSON.parse(praise_body_obj.replace(/[\r\n\s]+/gm, ' ')) : {};
    let title = null;
    let content = null;
    const pass = score > 80.0;
    if (isEmpty(praise_body)) {
        title = placeHolder ? (typeof placeHolder === 'string' ? placeHolder : placeHolder[0]) : null;
        content = placeHolder ? (typeof placeHolder === 'string' ? placeHolder : placeHolder[0]) : null;
    }
    else {
        const msgKey = pass ? 'pass' : 'fail';
        const titleKey = msgKey ? praise_title[msgKey] : [];
        const bodyKey = msgKey ? praise_body[msgKey] : [];
        const nlsTitleKey = titleKey ? titleKey[Math.floor(Math.random() * titleKey.length)] : '';
        const nlsBodyKey = bodyKey ? bodyKey[Math.floor(Math.random() * bodyKey.length)] : '';
        title = nlsTitleKey ? messages[nlsTitleKey] : '';
        content = nlsBodyKey ? messages[nlsBodyKey] : '';
    }
    const timeout = parseInt(quiz_end_timeout);
    const seconds = timeout ? timeout : 10;
    const closeTimer = () => {
        let counter = seconds;
        const interval = setInterval(() => {
            counter--;
            if (counter < 0) {
                clearInterval(interval);
                icache.set('isOpen', false);
            }
        }, 1000);
    };
    const closeModal = () => {
        icache.set('isOpen', false);
    };
    return w(Dialog, {
        open: icache.getOrSet('isOpen', true),
        key: 'quiz-end-modal',
        onOpen: closeTimer,
        onRequestClose: closeModal
    }, [
        {
            title,
            content
        }
    ]);
});
export default QuizEndModal;
